import * as React from 'react';

export function EmptyComponent() {
  return <h1>Coming soon</h1>;
}
